import { Component, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AppConfig } from '../app.config';
import * as http from '../common/http';
import * as utils from '../common/utils';
import { VideoPlayerComponent } from './video-player.component';

@Component({
  selector: 'video-select',
  templateUrl: './video-select.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoSelectComponent {

  static readonly DIALOG_ID = 'videoSelect';

  canPlay = false;
  filesList = [];

  private readonly videoFolder: string;

  @ViewChild(MatSelectionList, { static: true }) private filesSelectionList: MatSelectionList;

  constructor(public dialogRef: MatDialogRef<VideoSelectComponent>, private dialog: MatDialog) {
    this.videoFolder = `${AppConfig.settings.sharedDataServer}/${AppConfig.appName}/Video`;
  }

  static createDialogConfig() {
    return utils.createDialogConfig(false, true, VideoSelectComponent.DIALOG_ID);
  }

  async ngAfterViewInit() {
    this.filesList = await http.getFilesInFolder(this.videoFolder, /.*\.(mp4|avi|mkv)$/i) as string[];
    if (this.filesList.length == 0)
      return;

    this.canPlay = true;
  }

  async onPlay() {
    let selectedFile = this.filesSelectionList.selectedOptions.selected[0].getLabel();
    let videoUrl = `${this.videoFolder}/${selectedFile}`      
    let dialogConfig = await VideoPlayerComponent.createDialogConfig(videoUrl) as MatDialogConfig;

    this.dialog.open(VideoPlayerComponent, dialogConfig);
  }
}
